/*!
=========================================================
* リスト型ViewのBase
=========================================================
*/
import React, {useRef, createRef} from "react";

import {
    Card, CardHeader, CardBody,CardTitle,
    Row, Col,ListGroup, ListGroupItem,CardGroup,Button
} from "reactstrap";
import InputDatetime from '../FormParts/InputDatetime'
import Datetime from "react-datetime";
import moment from "moment";
import CustomTd from '../ViewParts/CustomTd';

import Request from '../../common/Request';
import ButtonWithTooltip from '../FormParts/ButtonWithTooltip';

const style= {
    monthText: {
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        // backgroundColor: "#f8f9fa",
        // borderRadius: "8px",
        cursor: "pointer",
        transition: "filter 0.3s ease-in-out",
    },
    calendarMonth: {
        padding: 0,
        width: "100px",
        height: "100px",
        border: "0.1px solid rgb(209, 209, 209)",
        marginBottom: "-1px",
        marginRight: "-1px",
        backgroundColor: "rgb(248, 249, 250)",
        display: "block",
        justifyContent: "center",
    },
    calendarMonth: {
        padding: 0,
        width: "100px",
        height: "100px",
        border: "0.1px solid rgb(209, 209, 209)",
        marginBottom: "-1px",
        marginRight: "-1px",
        backgroundColor: "rgb(248, 249, 250)",
        display: "block",
        justifyContent: "center",
    },
    currentMonth: {
        width:"100%",
        // height:"10px",
        color:"red",
        // borderRadius:"10px",
        fontSize: "10px",
        lineHeight: "10px",
    }
}

export default class ListBaseCalendar extends React.Component {
    constructor(props) {
        super(props);
        
        const thisYear = new Date().getFullYear();
        const thisMonth = new Date().getMonth() + 1;

        this.state = {
            title: '',
            // data: [],
            header_md:"6",
            // checkbox_field_in_table:false,
            currentYearMonth: thisYear * 100 + thisMonth, //現在年月
            selectedYear: thisYear, //選択中の年
            thisYear: thisYear, //今年
            // maxYear: thisYear + 10, //表示できる最新の年
            minYear: 2000, //表示できる一番過去の年
            selectedMonth: thisMonth,
            thisMonth: thisMonth, //今月
            disabledYearMonth: 202503,
            monthData: [],
            closingYearMonth: 202410, //締め処理可能月
            // auto_scroll:false // 自動スクロールフラグ 2021/06/08
        };

        this.searchWithPageIndex = this.searchWithPageIndex.bind(this)
        this.search = this.search.bind(this)
        /* 2021/06/08 scroll to list top */
        this.contentRef = createRef();
        this.pageChangeHandle = this.pageChangeHandle.bind(this);
    }

    componentDidUpdate(prevProps, prevState){
        console.log(this.state);
    }

    searchWithPageIndex(pageIndex = 0){
        this.setState({
            pageIndex
        })
        this.search()
    }

    handleMonthClick() {
        return null;
    }
    dataMap(data) {
        return null;
    }

    validate() {
        return false;
    }
    handleOutOfRange() {
        return false;
    }
    handleYearChange(date) {
        console.log(moment().format("YYYY-MM-DD"));
        console.log(date);
        const newYear = moment(date).year();
        this.setState({
            selectedYear: newYear
        });
    }

    search_params() {
        return {};
    }

    // 検索
    search() {
        /* ここは開発者が記述 */
        if (!this.validate()) {
            // do nothing
            return;
        }

        // Request.get(this.state.search_url, this.search_params(), res => {
        //     this.props.refreshTaskCount()
        //     this.setState({
        //         data: this.dataMap(res.data)
        //     });
        // })
        
    }

    dialog_defines() {
        return (
            <>
            </>
        );
    }
    dialog_out_of_range() {
        return (
            <>
            </>
        );
    }
    message_field_cols(){
        return (
            <>
            </>
        )
    }

    pageChangeHandle( customTable ){
        window.scrollTo(0,customTable.currentRef.current.offsetTop);
        return ;
    }

    toNextYear(){
        this.setState((prevState) => ({
            selectedYear: prevState.selectedYear + 1
        }));
    }
    toPreviousYear(){
        this.setState((prevState) => ({
            selectedYear: prevState.selectedYear - 1
        }));
    }

    handleMonthHover(e, isHover, exists){
        // exists true:月の締めデータあり false:データなし
        e.currentTarget.style.backgroundColor = isHover ? 
            "#e9ecef" : exists ? "rgb(198 198 198)" : "#f8f9fa";
    }

    render() {
        let dialog_defines = this.dialog_defines();
        let dialog_out_of_range = this.dialog_out_of_range();

        return (
            <>
                <div className="content">
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col md="12" className="HEADER">
                                            <Card className="CardBottomNone">
                                                <CardHeader>
                                                    <Row>
                                                        <Col md={this.state.header_md?this.state.header_md:"6"}>
                                                            <CardTitle tag="h3" className="float-left">
                                                                {this.state.title}
                                                            </CardTitle>
                                                        </Col>
                                                    </Row>
                                                </CardHeader>
                                            </Card>
                                        </Col>
                                        <CardBody className="d-flex justify-content-center">
                                            <Row className="d-flex justify-content-center w-50" style={{ borderSpacing: 0 }}>
                                                <Col md="12">
                                                    <CardTitle tag="h5" >月を選択してください</CardTitle>
                                                </Col>
                                                <Col md="12" className="mb-3">
                                                    <Row className="d-flex align-items-center justify-content-center">
                                                        <Col md="4" className="d-flex align-items-center justify-content-end">
                                                            {this.state.minYear < this.state.selectedYear &&
                                                                <Button onClick={()=> this.toPreviousYear()}>＜</Button>
                                                            }
                                                        </Col>
                                                        <Col md="4" className="d-flex align-items-center justify-content-center lm_claneder">
                                                            <Datetime
                                                                dateFormat="YYYY" // 年のみ表示
                                                                timeFormat={false} // 時刻選択を無効化
                                                                value={moment().year(this.state.selectedYear)}
                                                                onChange={(date) => this.handleYearChange(date)} // 年のみ取得
                                                                isValidDate={(current) => current.year() >= this.state.minYear}
                                                                renderInput={(props, openCalendar) => (
                                                                    <input
                                                                        {...props}
                                                                        onClick={openCalendar}
                                                                        // value={`${this.state.selectedYear} 年`}
                                                                        readOnly
                                                                        style={{
                                                                            fontSize: '24px',  // 年の表示を大きくする
                                                                            // fontWeight: 'bold', // 太字にする
                                                                            border: 'none', // 枠を非表示にする
                                                                            borderBottom: '1px solid #000', // 枠を非表示にする
                                                                            borderRadius: '0',
                                                                            textAlign: 'center', // 中央揃え
                                                                            backgroundColor: 'transparent', // 背景色を透明に
                                                                            // padding: '0', // パディングを調整
                                                                            cursor: 'pointer',
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                        </Col>
                                                        <Col md="4" className="d-flex align-items-center justify-content-start">
                                                            {/* {this.state.maxYear > this.state.selectedYear && */}
                                                                <Button onClick={()=> this.toNextYear()}>＞</Button>
                                                            {/* } */}
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((month, index) => {
                                                    const calendarYearMonth = this.state.selectedYear * 100 + month; // 表示月の年月 202502
                                                    const isDisabled = calendarYearMonth > this.state.disabledYearMonth; // 2024年より前の月はdisabled
                                                    const monthEntry = this.state.monthData.find(item => item.year_month == calendarYearMonth) //該当月のデータは存在するか
                                                    const exists = !!monthEntry
                                                    const monthId = monthEntry ? monthEntry.id : null;
                                                    console.log(calendarYearMonth);
                                                    // console.log(this.state.monthData);
                                                    console.log(monthEntry);
                                                    console.log(exists);
                                                    console.log(monthId);
                                                    return (
                                                        <Col
                                                            key={index}
                                                            md="3"
                                                            style={style.calendarMonth}
                                                        >
                                                            {this.state.closingYearMonth < calendarYearMonth ?
                                                                (
                                                                    <div
                                                                        style={{...style.monthText, backgroundColor: exists == true || !isDisabled ? "rgb(198 198 198)" : "#f8f9fa"}}
                                                                        onClick={() => this.handleOutOfRange(index + 1, exists, monthId)}
                                                                        onMouseEnter={isDisabled ? (e) => this.handleMonthHover(e,true, exists) : null}
                                                                        onMouseLeave={isDisabled ? (e) => this.handleMonthHover(e, false, exists) : null}
                                                                    >
                                                                        <div style={{width:"100%"}}>
                                                                            {month}月
                                                                            { calendarYearMonth == 202409 &&
                                                                                <div className="mr-1" style={style.currentMonth}>2024年9月以前の操作はできません</div>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                )


                                                                :(
                                                                <div
                                                                    style={{...style.monthText, backgroundColor: exists == true || !isDisabled ? "rgb(198 198 198)" : "#f8f9fa"}}
                                                                    onClick={
                                                                        
                                                                        isDisabled ? () => this.handleMonthClick(index + 1, exists, monthId) : null}
                                                                    onMouseEnter={isDisabled ? (e) => this.handleMonthHover(e,true, exists) : null}
                                                                    onMouseLeave={isDisabled ? (e) => this.handleMonthHover(e, false, exists) : null}
                                                                >
                                                                    <div style={{width:"100%"}}>
                                                                        {month}月
                                                                        { calendarYearMonth == 202409 &&
                                                                            <div className="mr-1" style={style.currentMonth}>2024年9月以前の操作はできません</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </Col>
                                                    )
                                                })}
                                            </Row>
                                        </CardBody>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
                {dialog_defines}
                {dialog_out_of_range}
            </>
        );
    }
}
